module.exports = __webpack_public_path__ + "img/visa.d2d4d9cf.svg";